import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { store } from './store';
import { loadEnvConfig } from './utils/env';
import { initializeMsal } from './services/msal';
import './i18n';
import './index.css';

// Load environment configuration and initialize MSAL
Promise.all([
  loadEnvConfig(),
  initializeMsal().catch(err => {
    // MSAL initialization might fail if Azure config is missing
    // This is okay in development, but should be configured for production
    console.warn(
      'MSAL initialization failed (this is okay if Azure config is not set):',
      err
    );
    return null; // Return null instead of throwing
  }),
]).then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </React.StrictMode>
  );
});
